import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Flex,
  Box,
} from '@chakra-ui/react';

const ServiceSettingCreateAndEditModal = ({
  isOpen,
  onClose,
  serviceSetting,
  onSave,
}) => {
  const [formData, setFormData] = useState({
    parent: '',
    instrument: '',
    serialNumber: '',
    brand: '',
    model: '',
    period: '',
  });

  useEffect(() => {
    if (serviceSetting) {
      setFormData({
        parent: serviceSetting.parent || '',
        instrument: serviceSetting.instrument || '',
        serialNumber: serviceSetting.serialNumber || '',
        brand: serviceSetting.brand || '',
        model: serviceSetting.model || '',
        period: serviceSetting.period || '',
      });
    } else {
      setFormData({
        parent: '',
        instrument: '',
        serialNumber: '',
        brand: '',
        model: '',
        period: '',
      });
    }
  }, [serviceSetting]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    const dataToSave = {
      ...formData,
      id: serviceSetting?.id,
    };
    onSave(dataToSave);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {serviceSetting ? 'Edit Service Setting' : 'Add Service Setting'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap={4}>
            <FormControl id="parent">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Parent
                </FormLabel>
                <Input
                  name="parent"
                  value={formData.parent}
                  onChange={handleChange}
                  placeholder="Parent"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="instrument">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Instrument
                </FormLabel>
                <Input
                  name="instrument"
                  value={formData.instrument}
                  onChange={handleChange}
                  placeholder="Instrument"
                  isRequired
                />
              </Flex>
            </FormControl>
            <FormControl id="serialNumber">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Serial Number
                </FormLabel>
                <Input
                  name="serialNumber"
                  value={formData.serialNumber}
                  onChange={handleChange}
                  placeholder="Serial Number"
                />
              </Flex>
            </FormControl>
            <FormControl id="brand">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Brand
                </FormLabel>
                <Input
                  name="brand"
                  value={formData.brand}
                  onChange={handleChange}
                  placeholder="Brand"
                />
              </Flex>
            </FormControl>
            <FormControl id="model">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Model
                </FormLabel>
                <Input
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                  placeholder="Model"
                />
              </Flex>
            </FormControl>
            <FormControl id="period">
              <Flex alignItems="center">
                <FormLabel mb={0} width="150px">
                  Period
                </FormLabel>
                <Input
                  name="period"
                  value={formData.period}
                  onChange={handleChange}
                  placeholder="Period"
                  type="number"
                  isRequired
                />
              </Flex>
            </FormControl>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ServiceSettingCreateAndEditModal;
